export default __webpack_public_path__ + "b882ff1cc70cad5eed6bc7f1fccc1df9.png";